// extracted by mini-css-extract-plugin
export default {"photo":"Photo_photo__+SP6C"};